import React from "react";
import "./ActionButton.css";

interface ActionButtonProps {
  icon?: React.ReactNode;
  text: string;
  onClick: () => void;
  responsive?: boolean;
  secondary?: boolean;
  disabled?: boolean;
  iconPosition?: "left" | "right"; // New prop to control icon position
}

const ActionButton: React.FC<ActionButtonProps> = ({
  icon,
  text,
  onClick,
  responsive = false,
  secondary = false,
  disabled = false,
  iconPosition = "left", // Default to left position
}) => {
  return (
    <button
      className={`action-button ${responsive ? "responsive" : ""} ${
        secondary ? "secondary" : ""
      } ${iconPosition === "right" ? "icon-right" : ""}`}
      disabled={disabled}
      onClick={onClick}
    >
      {iconPosition === "left" && icon}
      <span>{text}</span>
      {iconPosition === "right" && icon && (
        <span className="right-icon">{icon}</span>
      )}
    </button>
  );
};

export default ActionButton;
